import type { AgentApiCandidateFormAnswersShow } from '@/types/serializers';
import { useQuery } from '@tanstack/react-query';

export default function useFetchCandidateFormAnswer(answerId: number | null) {
  return useQuery({
    queryKey: ['candidate_form_answers', answerId],
    queryFn: async (): Promise<AgentApiCandidateFormAnswersShow> => {
      if (answerId == null) throw new Error('answerId is required');
      const response = await fetch(
        `/agent/api/candidate_forms/candidate_form_answers/${answerId}.json`
      );
      if (!response.ok) {
        throw new Error(`Failed to fetch candidate form answer: ${response.status}`);
      }
      const data: AgentApiCandidateFormAnswersShow = await response.json();
      return data;
    },
    enabled: answerId != null && answerId > 0,
  });
}
